import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthProvider";
import { determineAllowedRoute } from "../Utils/PermissionFunctions";

const LoginProtectedRoute = ({ children }) => {
  const location = useLocation();
  // function determineAllowedRoute(userData) {
  //   console.log(userData);

  //   const allowedPages = ["dashboard", "call-records", "vpbx-manager"];
  //   let allowedRoute = "notFound";

  //   // Iterate through each object in the userData array
  //   for (const page of userData) {
  //     // Check if the page_name is one of the allowedPages
  //     if (allowedPages.includes(page.page_name)) {
  //       // Check if either read_and_write or read_only is 1
  //       if (page.read_and_write === 1 || page.read_only === 1) {
  //         // Store the route of the first page found
  //         allowedRoute = page.page_name;
  //         break; // Exit loop once a valid page is found
  //       }
  //     }
  //   }
  //   return allowedRoute;
  // }

  const { auth } = useAuth();
  var route = "notFound";
  var loginStatus =
    auth?.loginStatus === "1" ||
    auth?.loginStatus === "2" ||
    auth?.loginStatus === "3"
      ? "loggedIN"
      : "notLoggedInd";

  if (auth.role === "3") {
    route = determineAllowedRoute();
  }
  if (loginStatus === "loggedIN") {
    return (
      <Navigate
        to={auth.role === "3" ? `/${route}` : "/dashboard"}
        // to={"/dashboard"}
        state={{ path: location.pathname }}
      />
    );
  }
  return children;
};

export default LoginProtectedRoute;
